/* import __COLOCATED_TEMPLATE__ from './resolve-query.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import type KnowledgeHubService from 'embercom/services/knowledge-hub-service';
import { inject as service } from '@ember/service';
import CustomBotListData from 'embercom/objects/operator/configuration/custom-bots/custom-bot-list-data';
import { objectTypes } from 'embercom/models/data/matching-system/matching-constants';
import { AI_AGENT_WORKFLOW_TARGET } from 'embercom/lib/operator/custom-bots/constants';
import { task } from 'ember-concurrency-decorators';
import { type TaskGenerator } from 'ember-concurrency';
import { taskFor } from 'ember-concurrency-ts';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: $TSFixMe;
    hasContent: boolean;
    isFinSdr: boolean;
  };
}

export default class ResolveQuery extends Component<Signature> {
  @service declare knowledgeHubService: KnowledgeHubService;
  @service declare appService: AppService;

  tasksData: CustomBotListData;

  constructor(owner: any, args: any) {
    super(owner, args);
    this.tasksData = new CustomBotListData(
      owner,
      this.appService.app.id,
      AI_AGENT_WORKFLOW_TARGET,
      objectTypes.triggerableCustomBot,
    );

    taskFor(this.loadTasks).perform();
  }

  @task({ restartable: true })
  *loadTasks(): TaskGenerator<void> {
    // setting the page size to 0 for speed, as we only need the count and this query retuns the total count anyway
    let response = yield this.tasksData.contentSearch(0, 0);
    this.tasksData.totalCount = response.totalCount;
  }

  get totalContentCount() {
    return Object.values(this.knowledgeHubService.usageSummary || {}).reduce(
      (acc, summary) => acc + summary.agent,
      0,
    );
  }

  get tasksCount() {
    return this.tasksData.totalCount;
  }

  get dataConnectorsCount() {
    // TODO get data connectors count
    return 1;
  }

  get manageContentRoute() {
    return 'apps.app.knowledge-hub.overview';
  }

  get manageTasksRoute() {
    return this.appService.app.isStandaloneApp
      ? 'apps.app.standalone.tasks.index'
      : 'apps.app.automation.fin-ai-agent.tasks';
  }

  get manageDataConnectorsRoute() {
    return 'apps.app.settings.app-settings.custom-actions';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::ConversationFlowSections::ResolveQuery': typeof ResolveQuery;
    'workflows/graph-editor/node-items/steps/fin/conversation-flow-sections/resolve-query': typeof ResolveQuery;
  }
}
